import React, { useEffect, useState } from 'react';
import {
    ActivityIndicator,
    FlatList,
    Text,
    TextInput,
    TouchableOpacity,
    View,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Header from '../../components/Header/Header';
import { styles } from './styles';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import TemporaryPasswordBanner from '../../components/TemporaryPasswordBanner/TemporaryPasswordBanner';
import { useUserStore } from '../../store/UserStore';
import { AppRoutes } from '../../navigation/Routes.types';
import ContainerItem from './components/ContainerItem/ContainerItem';
import ProductsService from '../../services/ProductsService/ProductsService';
import ContainersService from '../../services/ContainersService/ContainersService';
import { useAuthStore } from '../../store/AuthStore';
import { Colors } from '../../constants/Colors';
import { isTabletMode } from 'react-native-device-info';
import { getAnalytics, logEvent } from '@react-native-firebase/analytics';

interface IProduct {
    sku: string,
    image: string,
    qtContainers: number,
    description: string
    category?: string
}

const ContainersRequest = () => {
    const { goBack, navigate } = useNavigation();
    const [step, setStep] = useState<number>(0);
    const [selectedProducts, setSelectedProducts] = useState<IProduct[]>([]);
    const [products, setProducts] = useState<{ [key: string]: IProduct[] } | undefined>(undefined);
    const [categories, setCategories] = useState<string[]>();
    const [expandedCategories, setExpandedCategories] = useState<{ [key: string]: boolean }>({});
    const [quantities, setQuantities] = useState<{ [sku: string]: number }>({});
    const [loading, setLoading] = useState<boolean>(false);
    const temporaryPasswordLogin = useUserStore(state => state.temporaryPasswordLogin);
    const [loadingGet, setLoadingGet] = useState<boolean>(true);
    const [loadingCategories, setLoadingCategories] = useState<{ [key: string]: boolean }>({});
    const [successMessage, setSuccessMessage] = useState<string>('');
    const clientCode = useAuthStore()?.user?.current_client?.clientCode || useAuthStore()?.user?.clientCode;

    const handleNavigation = () => {
        if (step === 0) {
            if (selectedProducts.length > 0) {
                logEvent(analyticsInstance, 'containers_request_back_with_selection', {
                    client_code: clientCode,
                    selected_products_count: selectedProducts.length,
                });
            }
            (navigate as any)(AppRoutes.CONTAINERS);
        } else {
            setStep(0);
        }
    };

    const handleFinish = () => {
        (navigate as any)(AppRoutes.CONTAINERS, {refresh: true})
    }
    const analyticsInstance = getAnalytics();
    const handleStep = async () => {
        if (step === 0) {
            setStep(1);
        } else {
            setLoading(true);
            try {
                const containers = selectedProducts.map(product => ({
                    sku: product.sku,
                    product_name: product.description,
                    quantity: quantities[product.sku]
                }));
                logEvent(analyticsInstance, 'containers_request_submit', {
                    client_code: clientCode,
                    containers: containers,
                });
                await ContainersService.ContainerRequestPost(clientCode, containers);
                    setLoading(false);
                    setSuccessMessage('Um consultor irá entrar em contato em breve para tratar da sua solicitação.');
            setTimeout(() => {
                handleFinish();
            }, 5000);
            } catch (error) {
                console.error('Erro ao enviar solicitação de vasilhames:', error);
                setLoading(false);
            }
        }
    };

    const getContainersProducts = async () => {
        try {
            setLoadingGet(true)
            const containers = await ContainersService.ContainerProductsGet(clientCode);
            setProducts(containers);
            const categories = Object.keys(containers);
            setCategories(categories);
        } catch (error) {
            console.error('Erro ao buscar produtos de vasilhames:', error);
        } finally {
            setLoadingGet(false);
        }
    };

    useEffect(() => {
        getContainersProducts();
    }, []);

    const toggleExpandCategory = async (category: string) => {
        // setLoadingCategories(prevState => ({
        //     ...prevState,
        //     [category]: true
        // }));
        setExpandedCategories(prevState => ({
            ...prevState,
            [category]: !prevState[category]
        }));
    };

    const handleSelectProduct = (item: IProduct, category: string) => {
        item.category = category;
        const isSelected = selectedProducts.some(product => product.sku === item.sku);
        if (isSelected) {
            setSelectedProducts(selectedProducts.filter(product => product.sku !== item.sku));
        } else {
            setSelectedProducts([...selectedProducts, item]);
        }
    };

    const handleQuantityChange = (sku: string, quantity: number) => {
        setQuantities(prevState => ({
            ...prevState,
            [sku]: quantity
        }));
    };

    const allQuantitiesFilled = selectedProducts.every(product => quantities[product.sku] && quantities[product.sku] > 0);

    const renderCategory = (category: string) => (
        <View key={category}>
            <TouchableOpacity onPress={() => toggleExpandCategory(category)} style={styles.categoryContainer}>
                <Text style={styles.categoryText}>{category}</Text>
                <Text style={styles.icon}>
                    {expandedCategories[category] ? '-' : '+'}
                </Text>
            </TouchableOpacity>
            {
             expandedCategories[category] && (
               (
                    products && products[category].map(
                        (product: IProduct) => (
                            <ContainerItem key={product.sku} {...product} handleSelectProduct={() => handleSelectProduct(product, category)} selected={selectedProducts.some(p => p.sku === product.sku)} />
                        )
                    )
                )
            )}
        </View>
    );

    return (
        <View style={styles.container}>
            <View style={styles.containerHeader}>
                <SearchHeader onPress={step === 0 ?  goBack : () => setStep(0)} title="Vasilhames" />
                <Text style={styles.description}>
                    Solicite aqui seus Vasilhames
                </Text>
            </View>
            <TemporaryPasswordBanner />

            {loading ? (
                <View style={styles.loadingContainer}>
                    <ActivityIndicator size="large" color={Colors.RedPallete.red} />
                    <Text style={styles.loadingText}>Enviando solicitação...</Text>
                </View>
            ) : successMessage ? (
                <View style={styles.successContainer}>
                    <Text style={styles.successText}>{successMessage}</Text>
                </View>
            ) : (
                <>
                    {step === 0 ? 
                    (  
                        loadingGet ?
                        ( <ActivityIndicator size="large" color={Colors.RedPallete.red} /> ) :  (  <FlatList
                            style={{ paddingVertical: 10 }}
                            data={categories}
                            keyExtractor={(item) => item}
                            renderItem={({ item: category }) => renderCategory(category)}
                         />
                        )
                    ) : (
                       (<FlatList
                            style={{ paddingVertical: 10 }}
                            data={selectedProducts}
                            keyExtractor={(item) => item.sku}
                            renderItem={({ item: product }) => (
                                <ContainerItem
                                    key={product.sku}
                                    {...product}
                                    renderQuantityInput={(unitName) => (
                                        <>
                                            <Text style={{ color: 'black' }}>
                                               {unitName}:
                                            </Text>
                                            <TextInput
                                                style={styles.quantityInput}
                                                keyboardType="numeric"
                                                value={quantities[product.sku]?.toString() || ''}
                                                onChangeText={(text) => handleQuantityChange(product.sku, parseInt(text) || 0)}
                                                placeholder="0"
                                                placeholderTextColor={'gray'}
                                            />
                                        </>
                                    )}
                                />
                            )}
                        />)
                    )
                    
                    }

                    <View style={styles.containerFooter}>
                        {
                            step === 0 ? (
                                <ButtonComponent title='Continuar' onPress={handleStep} disabled={selectedProducts.length === 0 || temporaryPasswordLogin} />
                            ) : (
                                <ButtonComponent title='Confirmar solicitação' onPress={handleStep} disabled={!allQuantitiesFilled || temporaryPasswordLogin} />
                            )
                        }
                        <ButtonComponent title='Voltar' outlined onPress={handleNavigation} />
                    </View>
                </>
            )}
        </View>
    );
};

export default ContainersRequest;
